import { PaginatedList } from "@/datastructures/PaginatedList";
import { FormResponse } from "@/forms/FormResponse";
import { IMaterialRequestOverviewPresenter } from "../controllers/MaterialRequestOverviewController";
import { MaterialRequestOverviewViewModel } from "../vms/MaterialRequestOverviewViewModel";

export class MaterialRequestOverviewPresenter
  implements IMaterialRequestOverviewPresenter {
  public mounting = true;

  public constructor(private vm: MaterialRequestOverviewViewModel) {}

  public set tableRequest(response: FormResponse<PaginatedList<any>>) {
    this.vm.loading = response.loading;

    if (!response.loading && !response.error) {
      this.vm.items = response.data.items;
      this.vm.totalItems = response.data.totalCount;

      this.mounting = false;
    }
  }

  public get pageNumber() {
    return this.vm.pageNumber;
  }

  public set pageNumber(pageNumber: number) {
    this.vm.pageNumber = pageNumber;
  }

  public get itemsPerPage() {
    return this.vm.itemsPerPage;
  }

  public get options() {
    return this.vm.options;
  }

  public set options(options: any) {
    this.vm.options = options;
  }

  public set deleteRequest(response: FormResponse<string>) {
    this.vm.loading = response.loading;
  }

  public get search() {
    return this.vm.search;
  }

  public set setDoneRequest(response: FormResponse<string>) {
    this.vm.loading = response.loading;

    if (!response.loading && !response.error) {
      const itemIndex = this.vm.items.findIndex(
        item => item.id === response.data
      );
      if (itemIndex >= 0) {
        this.vm.items[itemIndex].done = true;
      }

      this.mounting = false;
    }
  }
}
